var render = function render(){var _vm=this,_c=_vm._self._c;return _c('drying-template',{attrs:{"drying-skin":_vm.dryingSkin,"dry-open-pores":_vm.dryOpenPores,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }